import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { TopBar } from "../components/TopBar";
import { api, formatDate } from "../lib/api";
import { Mail } from "lucide-react";

export default function NotificationsPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/notifications")
      .then((r) => setItems(r.data))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-zinc-50">
      <TopBar />
      <main className="mx-auto max-w-[1200px] px-4 sm:px-6 py-6">
        <div className="flex items-center justify-between mb-2 flex-wrap gap-2">
          <h1 className="font-heading text-3xl sm:text-4xl font-extrabold tracking-tighter text-zinc-950">
            Notifications
          </h1>
          <span className="text-[10px] uppercase tracking-widest font-semibold text-amber-700 bg-amber-50 border border-amber-200 px-2 py-1 rounded">
            MOCKED — emails are logged not sent
          </span>
        </div>
        <p className="text-sm text-zinc-600 mb-6">
          Mock email log for every key status change. Hook up Resend or SendGrid later to actually send.
        </p>

        <div className="bg-white border border-zinc-200 rounded-md shadow-sm overflow-hidden">
          {loading && <div className="p-8 text-center text-zinc-400 text-sm">Loading…</div>}
          {!loading && items.length === 0 && (
            <div className="p-12 text-center text-zinc-400 text-sm">No notifications yet.</div>
          )}
          <ul>
            {items.map((n) => (
              <li key={n.id} className="border-t border-zinc-100 first:border-t-0 px-4 py-3 hover:bg-zinc-50">
                <div className="flex items-start gap-3">
                  <div className="h-9 w-9 rounded-md bg-zinc-900 text-white flex items-center justify-center flex-shrink-0">
                    <Mail className="h-4 w-4" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center justify-between gap-2 flex-wrap">
                      <div className="font-semibold text-sm text-zinc-950">{n.subject}</div>
                      <div className="text-[11px] text-zinc-500">{formatDate(n.timestamp)}</div>
                    </div>
                    <div className="text-xs text-zinc-500 font-mono">To: {n.recipient}</div>
                    <div className="text-sm text-zinc-700 mt-1 whitespace-pre-line">{n.body}</div>
                    <Link to={`/bath/${n.bath_record_id}`} className="text-xs font-semibold text-zinc-950 hover:underline mt-2 inline-block" data-testid={`notif-link-${n.id}`}>
                      Open record ›
                    </Link>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </main>
    </div>
  );
}
